window.o_global = window.o_global || {};

o_global.device = o_global.device || {};

/**
 * Module to retrieve screen dimensions.
 *
 * @return {Object} Public methods.
 */
o_global.device.screen = (function() {
    "use strict";

    /**
     * Retrieve the width of the viewport.
     *
     * @return {Number} Width of device screen
     */
    function getWidth() {
        return window.innerWidth;
    }

    /**
     * Retrieve the height of the viewport.
     *
     * @return {Number} Height of device screen
     */
    function getHeight() {
        return window.screen.height;
    }

    /**
     * Return public methods.
     */
    return {
        "getWidth": getWidth,
        "getHeight": getHeight
    };
})();
